import { ErpSContractComponent } from "./shared/components/erp-scontract/erp-scontract.component";
import { DashboardComponent } from "./modules/dashboard/dashboard.component";
import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { PageNotFoundComponent } from "./modules/page-not-found/page-not-found.component";
import { ForgotPasswordComponent } from "./modules/forgot-password/forgot-password.component";
import { CommonCompComponent } from "./shared/components/common-comp/common-comp.component";
import { VerifyDocumentComponent } from "./modules/verify-document/verify-document.component";
import { AnonymousLoginComponent } from "./modules/login/anonymous-login/anonymous-login.component";
import { AnonymousSignViewDetailComponent } from "./modules/anonymous-view-detail/anonymous-sign-view-detail.component";
import { AnonymousSignFlowV2Component } from "./modules/anonymous-view-detail/anonymous-sign-flow-v2/anonymous-sign-flow-v2.component";
import { AnonymousSignFlowComponent } from "./modules/anonymous-view-detail/anonymous-sign-flow/anonymous-sign-flow.component";
import { PageShortLinkComponent } from "./modules/page-short-link/page-short-link.component";
import { BlankPageComponent } from "./modules/blank-page/blank-page.component";
import { ResetPasswordComponent } from "./modules/reset-password/reset-password.component";
import { ResetPasswordExistsComponent } from "./modules/reset-password/reset-password-exists/reset-password-exists.component";
import { PageErrorCodeComponent } from "./modules/page-error-code/page-error-code.component";
import { PageAnnouncementComponent } from "./modules/page-announcement/page-announcement.component";
import { PageErrorExpireComponent } from "./modules/page-error-expire/page-error-expire.component";
import { AuthCallbackComponent } from "./modules/auth-callback/auth-callback.component";
import { DowloadAppComponent } from "./modules/dowload-app/dowload-app.component";
import { MobileCaptchaComponent } from "./modules/mobile-captcha/mobile-captcha.component";
import { PageErrorApiLimitComponent } from "./modules/page-error-api-limit/page-error-api-limit.component";

const routes: Routes = [
  {
    path: "",
    component: DashboardComponent,
    children: [
      {
        path: "",
        loadChildren: () =>
          import("./modules/dashboard/dashboard.module").then(
            (m) => m.DashboardModule
          ),
      },
    ],
  },
  { path: "document-verify", component: VerifyDocumentComponent },
  { path: "download-app", component: DowloadAppComponent },
  {
    path: "sign-anonymous/:hashKey/:tenantId",
    component: AnonymousLoginComponent,
  },
  {
    path: "sign-anonymous/:hashKey/:tenantId/detail",
    component: AnonymousSignViewDetailComponent,
  },
  {
    path: "sign-anonymous/:hashKey/:tenantId/sign",
    component: AnonymousSignFlowV2Component,
  },
  {
    path: "sign-anonymous/:hashKey/:tenantId/sign-v1",
    component: AnonymousSignFlowComponent,
  },
  { path: "sign-anonymous", component: AnonymousLoginComponent },
  { path: "confirm", component: BlankPageComponent },
  {
    path: "reset-password/:hashKey/:tenantId",
    component: ResetPasswordComponent,
  },
  { path: "reset-password-exists", component: ResetPasswordExistsComponent },
  { path: "reset-password", component: ResetPasswordComponent },
  // {path: 'home', component: HomeComponent},
  { path: "request-password-reset/:id", component: ForgotPasswordComponent },
  { path: "common", component: CommonCompComponent },
  { path: "404", component: PageNotFoundComponent },
  { path: "callback", component: AuthCallbackComponent },
  { path: "v/:idContract", component: PageShortLinkComponent },
  { path: "s/:enterpriseId/:tenantId", component: PageShortLinkComponent },
  { path: "s/:enterpriseId/:tenantId/n", component: PageShortLinkComponent },
  { path: "erp-scontract", component: ErpSContractComponent },
  {
    path: "sign-anonymous/:hashKey/:tenantId/:contractIdAndContractEnterpriseIdEncode",
    component: AnonymousLoginComponent,
  },
  {
    path: "sign-anonymous/:hashKey/:tenantId/:contractIdAndContractEnterpriseIdEncode/detail",
    component: AnonymousSignViewDetailComponent,
  },
  {
    path: "sign-anonymous/:hashKey/:tenantId/:contractIdAndContractEnterpriseIdEncode/sign",
    component: AnonymousSignFlowV2Component,
  },
  {
    path: "sign-anonymous/:hashKey/:tenantId/:contractIdAndContractEnterpriseIdEncode/sign-v1",
    component: AnonymousSignFlowComponent,
  },
  { path: "v/:idContract", component: PageShortLinkComponent },
  { path: "s/:enterpriseId/:tenantId", component: PageShortLinkComponent },
  { path: "s/:enterpriseId/:tenantId/n", component: PageShortLinkComponent },
  { path: "erp-scontract", component: ErpSContractComponent },
  {
    path: "sign-anonymous/:hashKey/:tenantId/:contractIdAndContractEnterpriseIdEncode",
    component: AnonymousLoginComponent,
  },
  {
    path: "sign-anonymous/:hashKey/:tenantId/:contractIdAndContractEnterpriseIdEncode/detail",
    component: AnonymousSignViewDetailComponent,
  },
  {
    path: "sign-anonymous/:hashKey/:tenantId/:contractIdAndContractEnterpriseIdEncode/sign",
    component: AnonymousSignFlowV2Component,
  },
  // { path: 'sign-anonymous/:hashKey/:tenantId/:contractIdAndContractEnterpriseIdEncode/sign-v1', component: AnonymousSignFlowComponent },
  { path: "approval/success", component: PageAnnouncementComponent },
  { path: "approval/reject", component: PageAnnouncementComponent },
  { path: "error", component: PageErrorCodeComponent },
  { path: "api-rate-limit", component: PageErrorApiLimitComponent },
  { path: "expire", component: PageErrorExpireComponent },
  { path: "mobile-captcha", component: MobileCaptchaComponent },
  { path: "**", component: PageNotFoundComponent },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { onSameUrlNavigation: "reload" })],
  exports: [RouterModule],
})
export class AppRoutingModule {}
